<template>
  <v-container fluid>
    <div v-if="loading" class="d-flex justify-center align-center" style="min-height: 300px">
      <div class="text-center">
        <v-progress-circular indeterminate color="primary" size="60" />
        <p class="grey--text mt-4">Please wait...</p>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import { VERSIONED_API_URL } from '@/config/config'

export default {
  name: 'WorkPermit',
  data: () => ({
    loading: true,
    workPermitData: null,
  }),
  async mounted() {
    try {
      const response = await axios.post(`${VERSIONED_API_URL}/login/work-permit`)
      this.workPermitData = response.data.data.sso_code

      if (this.workPermitData) {
        const link = document.createElement('a')
        link.href = `https://workpermit.immigration.gov.np/sso-login?code=${this.workPermitData}`
        link.target = '_blank'
        link.rel = 'noopener noreferrer'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        await this.$router.push({name: 'Dashboard'})
      }
    } catch (error) {
      console.error('Work permit check failed:', error)
    } finally {
      this.loading = false
    }
  }
}
</script>